// Color-coded subscription / session status badge.
// Centralizes the active/reminder/grace/suspended palette so every page
// uses the same colors and capitalization.

const PRESETS = {
  active: { label: 'Active', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  reminder: { label: 'Renewal due', cls: 'bg-amber-50 text-amber-700 border-amber-200' },
  grace: { label: 'In grace', cls: 'bg-orange-50 text-orange-700 border-orange-200' },
  suspended: { label: 'Suspended', cls: 'bg-rose-50 text-rose-700 border-rose-200' },
  trialing: { label: 'Trialing', cls: 'bg-brand-50 text-brand-700 border-brand-200' },
  past_due: { label: 'Past due', cls: 'bg-orange-50 text-orange-700 border-orange-200' },
  inactive: { label: 'Inactive', cls: 'bg-surface-100 text-ink-600 border-surface-200' },
  master: { label: 'Master', cls: 'bg-amber-50 text-amber-700 border-amber-200' },
  admin: { label: 'Admin', cls: 'bg-brand-50 text-brand-700 border-brand-200' },
  manager: { label: 'Manager', cls: 'bg-violet-50 text-violet-700 border-violet-200' },
  staff: { label: 'Staff', cls: 'bg-cyan-50 text-cyan-700 border-cyan-200' },
  viewer: { label: 'Viewer', cls: 'bg-surface-100 text-ink-600 border-surface-200' },
  // Stage 5K-5A: per-user lifecycle states for the Users page.
  locked: { label: 'Locked', cls: 'bg-orange-50 text-orange-700 border-orange-200' },
  surrendered: { label: 'Surrendered', cls: 'bg-rose-50 text-rose-700 border-rose-200' }
};

export default function StatusBadge({
  status,
  label,
  tone,
  icon,
  className = ''
}) {
  const preset = (status && PRESETS[status]) || null;
  const cls =
    tone ||
    (preset && preset.cls) ||
    'bg-surface-100 text-ink-600 border-surface-200';
  const text = label || (preset && preset.label) || status || '—';
  return (
    <span
      className={
        'inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full border text-xs font-medium leading-5 ' +
        cls +
        ' ' +
        className
      }
    >
      {icon ? <span className="text-sm leading-none">{icon}</span> : null}
      {text}
    </span>
  );
}
